'use strict'

if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  require('promise/lib/rejection-tracking').enable()
  window.Promise = require('promise/lib/es6-extensions.js')
}

// Add Custom-Element support for IE11 as the <optional-img> webcomponent
// relies on it
/*
if (typeof window !== 'undefined' && !('customElements' in window)) {
	require('@webcomponents/webcomponentsjs/webcomponents-bundle.js')
}
*/

// fetch() polyfill for making API calls.
require('whatwg-fetch')

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = require('object-assign')

// window.URL() polyfill for processing strings as URLs.
require('url-polyfill')

// The polyfills below are all required by IE10.
require('core-js/es/map')
require('core-js/es/set')
require('core-js/es/weak-map')
require('core-js/es/weak-set')
require('core-js/es/symbol')
require('core-js/es/array')
require('core-js/features/string/includes')
require('core-js/features/string/starts-with')
require('core-js/features/string/ends-with')
require('core-js/features/array/includes')
require('custom-event-polyfill')
require('core-js/features/object/values')
